import { render, staticRenderFns } from "./IconPause.vue?vue&type=template&id=06787284"
import script from "./IconPause.vue?vue&type=script&lang=js"
export * from "./IconPause.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports